var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8.4px",
    height: "4.9px",
    viewBox: "0 0 8.4 4.9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.304827009
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres---Cat\\xE9gories",
    transform: "translate(-146.800000, -295.550000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(40.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(111.000000, 9.000000) rotate(-360.000000) translate(-111.000000, -9.000000) translate(104.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 14 0 14 14 0 14"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3.5 5.25 7 8.75 10.5 5.25"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownGrey);
export default __webpack_public_path__ + "static/media/icon_arrow_down_grey.e481f24f81e51d14635adf1e65631cc3.svg";
export { ForwardRef as ReactComponent };